// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD71c_aGdGKF1fuMK0GqbwvhlRz1I7rAIQ",
  authDomain: "pawtner-9602c.firebaseapp.com",
  projectId: "pawtner-9602c",
  storageBucket: "pawtner-9602c.firebasestorage.app",
  messagingSenderId: "1024030980396",
  appId: "1:1024030980396:web:fcc5929c5929a659529489",
  measurementId: "G-H29NKCVV6Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app)

export default db;
export { auth, storage };